export default "data:video/mp2t;base64,ZXhwb3J0IGVudW0gRVZFTlRfS0VZUyB7CiAgRU5URVIgPSAnRW50ZXInLAogIEVTQ0FQRSA9ICdFc2NhcGUnLAp9Cg=="